export default __webpack_public_path__ + "static/search-page-rhr-logo-6fcdf7eff8005ef0564a5635aabd8ea7.png";